import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * AIGeneratedBadge — Article 50 AI Act marker.
 *
 * Renders a small "Résumé IA" / "Généré par IA" label next to any content
 * produced or substantially modified by an LLM (summaries, translations).
 *
 * Props:
 *   variant: 'badge' (default) | 'inline'
 *   label:   custom label (defaults to "Résumé IA")
 */
const AIGeneratedBadge = ({ variant = 'badge', label = 'Résumé IA', className = '' }) => {
  if (variant === 'inline') {
    return (
      <span
        className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold ${className}`}
        style={{ color: 'var(--gold, #C9A86A)' }}
        data-testid="ai-generated-badge"
        title="Contenu généré ou traduit par IA (Article 50 AI Act)"
      >
        <Sparkles className="w-3 h-3" />
        {label}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border ${className}`}
      style={{
        color: 'var(--gold, #C9A86A)',
        borderColor: 'rgba(201,168,106,0.4)',
        background: 'rgba(201,168,106,0.08)',
      }}
      data-testid="ai-generated-badge"
      title="Contenu généré ou traduit par IA (Article 50 AI Act)"
    >
      <Sparkles className="w-3 h-3" />
      {label}
    </span>
  );
};

export default AIGeneratedBadge;
